import {byPropDesc, numericCompareAsc} from '@lib/utils';
import {createEntityAdapter} from '@reduxjs/toolkit';
import {Desk, SuggestedDesk} from '../entities';

export const desksAdapter = createEntityAdapter<Desk>({
  selectId: (desk) => desk.id,
  sortComparer: (d1, d2) => d1.name.localeCompare(d2.name),
});

export const suggestedDesksAdapter = createEntityAdapter<SuggestedDesk>({
  selectId: (suggestedDesk) => suggestedDesk.id,
  sortComparer: byPropDesc('score', numericCompareAsc),
});
